import { TaskCalendarScope } from "generated-graphql/graphql";
import { useState } from "react";

import {
  CalendarFilter,
  DEFAULT_CALENDAR_FILTER,
  parseCalendarFilterSearch,
  toCalendarFilterSearch,
} from "./calendarFilter";
import { CalendarSubscription } from "./useCalendarSubscription";

/**
 * The scope and custom filter being edited in the subscription dialog. Both
 * start at what's saved and only diverge once the user changes something.
 */
export function useCalendarSubscriptionDraft(subscription: CalendarSubscription | null) {
  const [draftScope, setScope] = useState<TaskCalendarScope | null>(null);
  const [draftFilter, setFilter] = useState<CalendarFilter | null>(null);

  const savedScope = subscription?.scope ?? TaskCalendarScope.All;
  const savedSearch =
    subscription?.scope === TaskCalendarScope.Custom ? (subscription.search ?? "") : "";
  const scope = draftScope ?? savedScope;
  const isCustom = scope === TaskCalendarScope.Custom;
  const filter =
    draftFilter ?? (savedSearch ? parseCalendarFilterSearch(savedSearch) : DEFAULT_CALENDAR_FILTER);
  const customSearch = toCalendarFilterSearch(filter);

  return {
    savedScope,
    scope,
    isCustom,
    filter,
    customSearch,
    changed: scope !== savedScope || (isCustom && customSearch !== savedSearch),
    missingFilter: isCustom && !customSearch,
    setScope,
    setFilter,
    reset: () => {
      setScope(null);
      setFilter(null);
    },
  };
}
